import { Navigate } from "react-router-dom";

const SecureRoute = (props) => {
  const isLogged = localStorage.getItem("isLogged") ? true : false;
  return <>{isLogged ? <>{props.children}</> : <Navigate to="/login" />}</>;
};

export default SecureRoute;
